import React from 'react';

import Location from './location';
import Hours from './hours';
import Contact from './contact';

import './index.scss';

const ContactPage = () => {
	return (
		<div className='contact-wrapper'>
			<Contact />
			<Location />
			<Hours />
		</div>
	);
};

export default ContactPage;
